import script from "./AgentPersonalitySelector.vue?vue&type=script&setup=true&lang=js"
export * from "./AgentPersonalitySelector.vue?vue&type=script&setup=true&lang=js"

import "./AgentPersonalitySelector.vue?vue&type=style&index=0&id=3d68ed52&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d68ed52"]])

export default __exports__